import styled from "styled-components"

import buttonTertiaryCss from "@irati/ui/src/Button/styled/tertiaryButtonCss"

interface Props {
  plain?: boolean
}

export default styled.span<Props>`
  ${({plain}) => !plain && buttonTertiaryCss}
`
